import React from 'react';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const MinistryHomeless = () => {
  return (
    <>
      <SEOHead path="/ministry-for-homeless-people" />
      <PageHeader title="Ministry for Homeless People" breadcrumb="Ministry for Homeless People" />

      <section className="section">
        <div className="container">
          <div className="content-page fade-in">
            <div className="content-body">
              <p>At Teen Challenge Armenia, we strongly believe in reaching those whom no one reaches. Our Ministry for Homeless People, under the dedicated leadership of Aramayis Mirzoyan, exemplifies this belief. We strive to reach out to the homeless, not just to meet their immediate physical needs, but to offer them hope, love, and a chance for transformation.</p>

              <p>Our ministry operates through regular outreach days focused on seeking out the homeless and providing them with essential care. In addition to sharing the life-transforming love of God and the Gospel, we furnish them with vital necessities including food and clothing. However, our mission extends further than just meeting these immediate needs.</p>

              <p>During our outreach days, we often encounter individuals suffering from acute infectious diseases such as HIV, AIDS, Tuberculosis, and others. We also come across those who are gripped by the clutches of addiction. Acknowledging the severity of these conditions, we ensure these individuals are immediately admitted to hospitals for urgent care. From first aid to detoxification, every necessary step is taken to safeguard their health.</p>

              <p>After the immediate care, individuals addicted to substances are transferred to the Rehab Center in Hrazdan for a comprehensive recovery process. Simultaneously, those battling infectious diseases continue to receive hospital care until they are strong enough to reintegrate into society.</p>

              <p>We are able to facilitate these medical interventions free of cost, thanks to the mandate granted by the Armenian government to Teen Challenge Armenia.</p>

              <p>With dedication and faith, we aim to help the marginalized reclaim their lives. In reaching out to the homeless, we strive to bring about a positive change, sharing God's love and offering support when they need it most. We believe that with compassion, care, and the right help, everyone can find a path to a better future.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MinistryHomeless;
